import { styled } from '@linaria/react';

function SpreadDemo() {
  return (
    <Wrapper>
      <BoxOne />
      <BoxTwo />
      <BoxThree />
      <BoxFour />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  justify-items: center;
  padding: 48px;
  gap: 48px;
  margin-bottom: 48px;
  background: hsl(285deg 90% 90%);
  border-radius: 8px;
`;

const Box = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  background: white;
  border-radius: 8px;
`;

const BoxOne = styled(Box)`
  box-shadow: 0px 4px 8px hsl(0deg 0% 0% / 0.5);
`;
const BoxTwo = styled(Box)`
  box-shadow: 2px 4px 4px hsl(285deg 25% 40% / 0.75);
`;
const BoxThree = styled(Box)`
  box-shadow: 0px 4px 40px hsl(0deg 0% 0% / 0.5);
`;
const BoxFour = styled(Box)`
  box-shadow: -8px 4px 4px hsl(285deg 30% 30% / 1);
`;

export default SpreadDemo;
